import moment from "moment/moment";

export const DateFormat = (date) => {
  if(!date) return "";

  return moment(date).format("DD/MM/YYYY");
}